import { Alert } from '@mui/material'
import { useMemo } from 'react'

import getValidSpec from '@/utils/getValidSpec'

import DataDumpConfigValidator from '../helpers/dataDumpValidator'

export default function DataDumpValidator({ dataDump }: { dataDump: string }) {
  const result = useMemo(() => {
    try {
      let spec = getValidSpec(dataDump)
      console.log('Validating spec:', spec)

      let validationErrors: string[] = []
      const customConsole = {
        ...console,
        error: (msg: string, ...args: any[]) => {
          validationErrors.push(msg)
        },
      }
      const validator = new DataDumpConfigValidator(console)
      validator.validate(spec.data)
      return {
        errors: validationErrors,
        success: validationErrors.length === 0,
      }
    } catch (e) {
      return { errors: [(e as Error).message], success: false }
    }
  }, [dataDump])
  return (
    <Alert severity={result.success ? 'success' : 'error'}>
      {!!result.errors.length && (
        <ul>
          {result.errors.map((err, idx) => (
            <li key={idx}>{err}</li>
          ))}
        </ul>
      )}
      {result.success && 'Data dump is valid!'}
    </Alert>
  )
}
